import { render, staticRenderFns } from "./ModuleAccessWalletMobile.vue?vue&type=template&id=2f354c86&scoped=true"
import script from "./ModuleAccessWalletMobile.vue?vue&type=script&lang=js"
export * from "./ModuleAccessWalletMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f354c86",
  null
  
)

export default component.exports